import type { ServiceStatusData } from '@ps/web-shared-api-types/v1-preview/SwHomeGames';
import { useEffect } from 'react';
import { useStore } from 'react-redux';

import { requestStream } from '@swf/core/api/requestStream';
import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';

import ENDPOINTS from '../../../../../constants/endpoints';
import { useHomeGamesWidget } from '../../../../../model';

const useServiceStatusStream = () => {
  const { widgetDispatch } = useHomeGamesWidget();
  const { getState } = useStore<RootState>();
  const options = select.cms.getRequestOptions(getState());

  useEffect(() => {
    const sub = requestStream<{ data: ServiceStatusData[] }>({
      service: ENDPOINTS.serviceStatusStream,
      body: {},
      ...options
    }).subscribe({
      next: ({ data }) => {
        if (data) {
          widgetDispatch.updateServiceStatusData({ response: data });
        }
      }
    });

    return () => {
      widgetDispatch.clearServiceStatus();
      sub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useServiceStatusStream;
